import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonComponent } from './layouts/common/common.component';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'candidate/list',
    pathMatch: 'full',
  },
  {
    path: '',

    component: CommonComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'candidate',
        loadChildren: () =>
          import('./modules/candidate/candidate.module').then(
            (m) => m.CandidateModule
          ),
        data: {
          title: 'Candidate',
        },
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('./modules/clients/clients.module').then(
            (m) => m.ClientsModule
          ),
        data: {
          title: 'Clients',
        },
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
